export enum ContributionType {
  Automatic = 'Automatic',
  Manual = 'Manual',
  None = 'None',
}
